import './style.css';
import { jsx as o } from "react/jsx-runtime";
import { c as p } from "../../__shared__/index.js";
const h = "_content_18wxu_1", i = "_hideEmptyParagraphs_18wxu_57", r = {
  content: h,
  hideEmptyParagraphs: i
};
function _({
  children: t = "",
  as: a = "div",
  className: s,
  style: e,
  showEmptyParagraphs: m,
  ...n
}) {
  return /* @__PURE__ */ o(
    a,
    {
      ...n,
      className: p(r.content, s, {
        [r.hideEmptyParagraphs]: !m
      }),
      style: e,
      dangerouslySetInnerHTML: { __html: (t == null ? void 0 : t.trim()) || "" }
    }
  );
}
export {
  _ as default
};
//# sourceMappingURL=FormattedText.js.map
